import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
export const EmptyState = ({ title, description }) => (<Card className="border-dashed bg-muted/30">
        <CardHeader>
            <CardTitle className="text-base">{title}</CardTitle>
        </CardHeader>
        <CardContent>
            {description && <p className="text-sm text-muted-foreground">{description}</p>}
            <p className="text-sm text-muted-foreground mt-1">No data yet.</p>
        </CardContent>
    </Card>);
EmptyState.displayName = 'EmptyState';
